import { object } from 'prop-types'
import React from 'react'

import FacilityNote from './FacilityNote'

const FacilityOverview = ({ intl, facility }) => {
  return (
    <div className="container-relative">
      <div className="lead-copy">
        <FacilityNote
          notes={facility.notes}
          noteType="BROCHURE_INFO"
          intl={intl}
        />
      </div>
    </div>
  )
}

FacilityOverview.propTypes = {
  intl: object.isRequired,
  facility: object.isRequired,
  params: object.isRequired,
}

export default FacilityOverview
